module.exports = "/build/admin/images/logo-topgeschenken.0eacd0c8.png";